module.exports = __webpack_public_path__ + "img/NewsArticlesComingSoon-Web.131aaa0d.png";